import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import ChartUserByCountry from '../ChartUserByCountry';
import CustomizedDataGrid from '../CustomizedDataGrid';
import CustomizedTreeView from '../CustomizedTreeView';
import Copyright from '../internals/components/Copyright';
import { collection, getDocs } from "firebase/firestore";
import { useEffect, useState } from "react";
import { db } from "../../../firebase"; 
import { useContext } from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { EventContext } from "../../../pages/Dashboard";
import { useParams, Outlet } from "react-router-dom";
import { doc, updateDoc } from "firebase/firestore";

const People = ({ eventDocId }) => {

  const [guestRows, setGuestRows] = useState([]);
  const {eventDetails} = useContext(EventContext); 
  const eventCode = eventDetails?.eventCode;  
  const eventID = eventDetails?.eventId; 

  useEffect(() => {
    const fetchGuests = async () => {
      if (!eventID) return;

      const guestsRef = collection(db, "events", eventID, "guests");
      const snapshot = await getDocs(guestsRef);

      const rows = snapshot.docs.map((doc, index) => ({
        id: doc.id,
        guestEmail: doc.data().guestEmail,
        guestRole: doc.data().guestRole,
        guestLobby: doc.data().guestLobby,
        guestRSVP: doc.data().guestRSVP ? "Yes" : "No",
        guestNotes: doc.data().guestNotes,
        guestCheckedIntime: doc.data().guestCheckedIntime?.toDate().toLocaleString() || "-",
      }));

      setGuestRows(rows);
    };

    fetchGuests();
  }, [eventID]);

  const columns = [
    { field: "guestEmail", headerName: "Email", width: 250 },
    { field: "guestRole", headerName: "Role", width: 110 },
    { field: "guestLobby", headerName: "Lobby", width: 150 },
    { field: "guestRSVP", headerName: "RSVP", width: 100},
    { field: "guestNotes", headerName: "Guest notes", width: 342 },
    { field: "guestCheckedIntime", headerName: "Check-in time", width: 200 },
  ];

  return (
    <Box sx={{ width: '100%', maxWidth: { sm: '100%', md: '1700px' } }}>
      {/* cards */}
      <Typography component="h2" variant="h6" sx={{ mb: 2 }}>
        People {eventID}
      </Typography>
      <Typography component="h2" variant="h6" sx={{ mb: 2 }}>
        Details
      </Typography>
      <Grid container spacing={2} columns={12}>
        <Grid size={{ xs: 12, lg: 9 }}>
        <DataGrid
        rows={guestRows}
        columns={columns}
        checkboxSelection
        disableRowSelectionOnClick
        pagination
        pageSizeOptions={[5, 10, 25]}
        slots={{ toolbar: GridToolbar }}
        initialState={{
          pagination: { paginationModel: { pageSize: 10, page: 0 } },
          sorting: { sortModel: [{ field: "guestEmail", sort: "asc" }] }
        }}
      />
         
        </Grid>
        <Grid size={{ xs: 12, lg: 3 }}>
          <Stack gap={2} direction={{ xs: 'column', sm: 'row', lg: 'column' }}>
            <CustomizedTreeView />
            <ChartUserByCountry />
          </Stack>
        </Grid>
      </Grid>
      <Copyright sx={{ my: 4 }} />
    </Box>
  );
};
export default People;